export function formatCurrencyToMil(value?: string | number) {
  try {
    if (!value) return 'R$ 0 mil';

    const stringValue = typeof value === 'number' ? value.toString() : value;
    const numericValue = parseFloat(
      stringValue.replace('R$', '').replace(/\./g, '').replace(',', '.').trim()
    );

    if (Number.isNaN(numericValue)) return 'R$ 0 mil';

    const valueInThousands = (numericValue / 1000).toFixed(0);
    return `R$ ${valueInThousands} mil`;
  } catch (error) {
    return 'R$ 0 mil';
  }
}

export const days: { [key: string]: string } = {
  Sunday: 'Dom',
  Monday: 'Seg',
  Tuesday: 'Ter',
  Wednesday: 'Qua',
  Thursday: 'Qui',
  Friday: 'Sex',
  Saturday: 'Sáb',
};

export function translateDay(day: string): string {
  return days[day] || day;
}

export const chartColors = {
  donut: ['#9747FF', '#FF4747', '#FFB947', '#47FF85', '#47D4FF', '#96CEB4'],
  line: {
    campaigns: {
      border: '#03CFBB',
      background: 'rgba(3, 207, 187, 0.1)',
    },
    impressions: {
      border: '#FF9447',
      background: 'rgba(255, 148, 71, 0.1)',
    },
  },
};
